import type { CommentBody as CommentBodyValue } from '@liveblocks/client'
import { Comment } from '@liveblocks/react-ui/primitives'

import { COMMENT_BODY_COMPONENTS } from './consts'

type CommentBodyProps = {
  body: CommentBodyValue
}

export const CommentBody = ({ body }: CommentBodyProps) => (
  <Comment.Body
    body={body}
    className='whitespace-pre-wrap break-words text-main-foreground-secondary text-body-default'
    components={COMMENT_BODY_COMPONENTS}
  />
)
